import { Lightbulb } from "lucide-react";

// PLAN1.2 – „Doppel-Wow": zusätzliche Themen-Vorschläge UNTER der vollständigen
// Dokumentenvorschau. Reine Anzeige (Titel + 1-Satz-Begründung + Bausteine-Tags).
// Erzeugt KEINE Welten. Wird nur gerendert, wenn es Vorschläge gibt.

const TAG_LABELS = {
  gbu: "Gefährdungsbeurteilung",
  betriebsanweisung: "Betriebsanweisung",
  unterweisung: "Unterweisung",
  verstaendnisfragen: "Verständnisfragen",
  pruefung_wartung: "Prüf-/Wartung",
  wiedervorlage: "Wiedervorlage",
};

export default function WeltVorschlaege({ suggestions }) {
  if (!suggestions || suggestions.length === 0) return null;

  return (
    <section className="wrap lp-vorschlaege" data-testid="lp-vorschlaege-section"
      style={{ marginTop: 8, marginBottom: 56 }}>
      <h2 style={{ display: "flex", alignItems: "center", gap: 8, fontSize: "1.25rem", fontWeight: 700, color: "#0f172a", margin: "0 0 6px" }}>
        <Lightbulb size={20} color="#f59e0b" /> Zusätzlich relevant für Ihren Betrieb
      </h2>
      <p style={{ color: "#64748b", fontSize: "0.95rem", margin: "0 0 20px", maxWidth: 640 }}>
        Diese Dokumentationswelten passen typischerweise zu Ihrem Betrieb – im kostenlosen Test mit einem Klick erstellbar.
      </p>

      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(260px, 1fr))", gap: 14 }}>
        {suggestions.map((s, i) => (
          <div
            key={i}
            data-testid={`lp-vorschlag-item-${i}`}
            style={{
              border: "1px solid #e2e8f0",
              borderRadius: 14,
              padding: "16px 18px",
              background: "#fff",
              boxShadow: "0 1px 2px rgba(15,23,42,0.04)",
            }}
          >
            <div data-testid={`lp-vorschlag-titel-${i}`} style={{ fontWeight: 650, color: "#0f172a", fontSize: "1rem", marginBottom: 6 }}>
              {s.titel}
            </div>
            {s.kurzbegruendung && (
              <div style={{ color: "#475569", fontSize: "0.875rem", lineHeight: 1.45, marginBottom: 10 }}>
                {s.kurzbegruendung}
              </div>
            )}
            {s.bausteine_tags?.length > 0 && (
              <div data-testid={`lp-vorschlag-tags-${i}`} style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
                {s.bausteine_tags.map((t) => (
                  <span
                    key={t}
                    style={{
                      fontSize: "0.72rem",
                      fontWeight: 600,
                      color: "#334155",
                      background: "#f1f5f9",
                      border: "1px solid #e2e8f0",
                      borderRadius: 999,
                      padding: "3px 9px",
                    }}
                  >
                    {TAG_LABELS[t] || t}
                  </span>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </section>
  );
}
